var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.obj_to_null(this.item)
    ? _c(
        "div",
        { staticClass: "categ_info" },
        [
          _c("info_field", {
            attrs: {
              f_uniq: "ct222",
              f_type: "card_pay",
              f_title: _vm.__t("CARD_NUMBER"),
              is_disabled: _vm.is_disabled,
              f_val: _vm.item.card_pay,
            },
            on: { update_categ: _vm.change_atr },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "okpo",
              f_type: "okpo",
              f_title: _vm.__t("OKPO_IPN"),
              is_disabled: _vm.is_disabled,
              f_val: _vm.item.okpo,
            },
            on: { update_categ: _vm.change_atr },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }